import { Injectable } from "@angular/core";
import { FormControl, FormControlStatus, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { FILTER_API_DATE_FORMAT } from "@common/constants";
import { TranslateService } from "@ngx-translate/core";
import moment from "moment";
import { filter } from "rxjs";
import { CommonService } from "src/app/common.service";
import { PopupComponent } from "src/app/common/components/popup/popup.component";
import { DebitCardImagesListService } from "src/app/common/services/debit-card-image-list/debit-card-image-list.service";
import { BaseFpxFormHelper, BaseFpxComponentState, BaseFpxChangeHandler } from "src/app/common/utils/base-fpx.form.component";
import { InfoPopupComponent } from "src/app/core/components/popup/info-popup/info-popup.component";
import { RetailStock } from "src/app/retail-common.service";
import { ServiceStock } from "src/app/service-stock.service";
import { BeneficiaryService } from "src/app/services/beneficiary/beneficiary.service";
import { TransfersService } from "src/app/services/transfers/transfers.service";


export class PaymentsFiltertState extends BaseFpxComponentState {
  catagoryType;
  isDateValid:boolean;
}

@Injectable({
  providedIn: 'root',
})
export class PaymentsFiltertHelper extends BaseFpxFormHelper<PaymentsFiltertState> {
  // private _beneList:any = [];
  constructor(
    public _beneficiaryService: BeneficiaryService,

    private retailStock: RetailStock,
    public services: ServiceStock,
    protected translate: TranslateService,
    public _transferServices: TransfersService,
    public _commonService: CommonService
  ) {
    super(new PaymentsFiltertState());
    this.addChangeHandler('fromDate', this.doFromDateChange);
    this.addChangeHandler('toDate', this.doToDateChange);
  }

  private doFromDateChange: BaseFpxChangeHandler = (
    name: string,
    status: FormControlStatus,
    value: any,
    formGroup: FormGroup
  ) => {
    if (value) {
      // formGroup.get('fromDate').setErrors(null, { emitEvent: false });
      let fromDateValue = formGroup.get('fromDate').value;
      let toDateValue = formGroup.get('toDate').value;
      this.checkFromAndToRequired(formGroup);
      // formGroup.controls['fromDate'].setValidators([Validators.required]);
      // formGroup.controls['toDate'].setValidators([Validators.required]);
      if (
        fromDateValue != '' &&
        toDateValue != '' &&
        moment(fromDateValue).isBefore(moment(toDateValue))
      ) {
        this.state.isDateValid = true
        // formGroup.get('toDate').setErrors({ fromDateGreaterError: true }, { emitEvent: false });
      } else {
        // formGroup.get('toDate').setErrors(null, { emitEvent: false });
      }
    } else if (value == '') {
    }

    // formGroup.controls["fromDate"].updateValueAndValidity();
    // formGroup.controls["toDate"].updateValueAndValidity();
  };

  private doToDateChange: BaseFpxChangeHandler = (
    name: string,
    status: FormControlStatus,
    value: any,
    formGroup: FormGroup
  ) => {
    if (value) {
      // formGroup.get('fromDate').setErrors(null, { emitEvent: false });
      let fromDateValue = formGroup.get('fromDate').value;
      let toDateValue = formGroup.get('toDate').value;
      this.checkFromAndToRequired(formGroup);
      // formGroup.controls['fromDate'].setValidators([Validators.required]);
      // formGroup.controls['toDate'].setValidators([Validators.required]);
      if (
        fromDateValue != '' &&
        toDateValue != '' &&
        moment(fromDateValue).isAfter(moment(toDateValue))
      ) {
        this.state.isDateValid = true
        // formGroup.get('fromDate').setErrors({ toDateGreaterError: true }, { emitEvent: false });
      } else {
        // formGroup.get('fromDate').setErrors(null, { emitEvent: false });
      }
    } else if (value == '') {
    }

    // formGroup.controls["fromDate"].updateValueAndValidity();
    // formGroup.controls["toDate"].updateValueAndValidity();
  };

  checkFromAndToRequired(formGroup:FormGroup) {
    let fromDateValue = formGroup.get('fromDate').value;
    let toDateValue = formGroup.get('toDate').value;
    if ((fromDateValue != '' && toDateValue == '' ) || (fromDateValue == '' && toDateValue != '' )){
      this.state.isDateValid = true
    }else{
      this.state.isDateValid = false
    }

  }

  public doConfirm(context: any, success: any, failure: any) {
    let fromDateValue = context.fromDate;
    let toDateValue = context.toDate;
    let apifromDateValue = moment(context.fromDate).format(FILTER_API_DATE_FORMAT);
    let apitoDateValue = moment(context.toDate).format(FILTER_API_DATE_FORMAT);
    let filter;
    filter = {
      "FilterExpression": "",
      "FilterCriteria": [
        {
          "columnName": "paymentSystem",
          "columnType": "String",
          "conditions": {
            "searchType": "equals",
            "searchText": ""
          }
        },
        {
          "columnName": "status",
          "columnType": "String",
          "conditions": {
            "searchType": "equals",
            "searchText": "3"
          }
        }
      ],
      "OrderCriteria": [
        {
          "columnName": "createdOn",
          "columnType": "Timestamp",
          "orderType": "desc"
        }
      ]
    }

    if (this.state.catagoryType == 'all' && fromDateValue == "" && toDateValue == "") {
      filter = {"FilterExpression": "C1", "FilterCriteria": [{"columnName": "status", "columnType": "String", "conditions": {"searchType": "equals", "searchText": "3"} } ], "OrderCriteria": [{"columnName": "createdOn", "columnType": "Timestamp", "orderType": "desc"} ] }
    }
    //  else if (this.state.catagoryType == 'fav') {
    //   filter.FilterCriteria[0].columnName = 'beneName'
    //   filter.FilterCriteria[0].conditions.searchText = 'Mary';
    //   filter.FilterExpression = 'C1'
    // }
     else if (this.state.catagoryType == 'OAT'  || this.state.catagoryType == 'INTBT' || this.state.catagoryType == 'ACH' || this.state.catagoryType == 'SWIFT') {
      filter.FilterCriteria[0].columnName = 'paymentSystem'
      filter.FilterCriteria[0].conditions.searchText = this.state.catagoryType;
      filter.FilterExpression = 'C1ANDC2'
    }

    if (fromDateValue != "" && toDateValue != "" && this.state.catagoryType == 'all') {
      filter.FilterCriteria.shift();
      filter.FilterExpression = 'C1ANDC2';
      filter.FilterCriteria.push({ "columnName": "createdOn", "columnType": "Timestamp", "conditions": { "searchType": "inRange", "dateFrom": "" +apifromDateValue+" "+"00:00:00", "dateTo": "" + apitoDateValue+" "+"23:59:59" } })
    }

    else if (fromDateValue != "" && toDateValue != "") {
      filter.FilterExpression = 'C1ANDC2ANDC3'
      filter.FilterCriteria.push({ "columnName": "createdOn", "columnType": "Timestamp", "conditions": { "searchType": "inRange", "dateFrom": "" + apifromDateValue+" "+"00:00:00", "dateTo": "" + apitoDateValue+" "+"23:59:59" } })
    }
    this._transferServices.paymentHistoryFilterValue = { fromDate: fromDateValue, toDate: toDateValue, catagoryType: this.state.catagoryType }
    this._transferServices.refreshWithfilterPaymentHistory.next(JSON.stringify(filter));
    success()
  }
}